export const getLastPayment = (cartOrOrder) => {

  const payments = cartOrOrder?.paymentInfo?.payments;

  return payments && payments.length > 0 ? payments[payments.length - 1] : undefined;

};
